import {
  Box,
  Button,
  HStack,
  Text,
  VStack,
} from '@chakra-ui/react'
import { useThemeColors } from '@/hooks/useThemeColors'
import { ParentTicketAttachmentsList } from '@/components/helpdesk/TicketDetail/ParentTicketAttachmentsList'
import type { ParentTicketAttachment } from '@/types/ticket'
import { TicketService } from '@/lib/services/ticket'

type Props = {
  ticketId: string
  attachments?: ParentTicketAttachment[]
  childTicketId?: number | null
  onUpload?: (ticketId: string, file: File) => Promise<void>
  isReadOnly?: boolean
}

export default function WorkPermitPanel({
  ticketId,
  attachments = [],
  childTicketId,
  onUpload,
  isReadOnly,
}: Props) {
  const colors = useThemeColors()
  const taskAttachments = attachments.filter((item) => item.source === 'task')

  return (
    <Box mt={4} pt={4} borderTop="1px solid" borderColor={colors.borderLight}>
      <Text fontSize="sm" fontWeight="700" mb={2}>
        Work permit
      </Text>
      <VStack align="stretch" spacing={3}>
        {!isReadOnly && onUpload ? (
          <HStack spacing={3} flexWrap="wrap" align="flex-start">
            <Button
              size="sm"
              variant="solid"
              colorScheme="blue"
              as="label"
              cursor="pointer"
              sx={{ '& input': { display: 'none' } }}
            >
              Upload
              <input
                type="file"
                accept=".pdf,.doc,.docx,image/*"
                onChange={(e) => {
                  const file = e.target.files?.[0]
                  if (file) {
                    onUpload(ticketId, file).finally(() => {
                      e.target.value = ''
                    })
                  }
                }}
              />
            </Button>
          </HStack>
        ) : null}
        <ParentTicketAttachmentsList
          ticketId={ticketId}
          attachments={taskAttachments}
          sourceFilter="task"
          title="Task attachments"
          emptyMessage="No work permit attached yet."
        />
      </VStack>
    </Box>
  )
}

export async function uploadTaskWorkPermitAttachment(
  ticketId: string,
  file: File,
  childTicketId?: number | null,
): Promise<void> {
  await TicketService.uploadParentTicketAttachments(ticketId, {
    rows: [{ attachmentType: 'work_permit', file, fileName: file.name }],
    source: 'task',
    replace: false,
    childTicketId: childTicketId ?? null,
  })
}
